import * as h2Api from '../../h2Api'
import { browserHistory } from '../../Routes'

export const REPORT_LOAD_DATA = 'REPORT_LOAD_DATA'
export const UPDATE_REPORT_FIELD = 'UPDATE_REPORT_FIELD'
export const UPDATE_FILTER_KIND = 'UPDATE_FILTER_KIND'

export const loadReportData = filter => {
  return h2Api.post('/admin/reports/logins', filter)({ type: REPORT_LOAD_DATA })
}

export const loadUsagebyTypeReportData = filter => {
  return h2Api.post('/admin/reports/usageByType', filter)({ type: REPORT_LOAD_DATA })
}

export const updateFilterKind = kind => (dispatch, getState) => {
  dispatch({ type: UPDATE_FILTER_KIND, kind })

  return Promise.resolve(getState().admin.reporting.filter)
}

export const loadUsagebyObjectTypeReportData = (filter, ignoreRedirectCheck) => (
  dispatch,
  getState
) => {
  const requireRouteChange = getState().admin.reporting.requireRouteChange

  if (requireRouteChange && !ignoreRedirectCheck) {
    browserHistory.replace(`/admin/reporting/usagebytype/${filter.kind}`)

    return Promise.resolve(true)
  }

  return dispatch(
    h2Api.post('/admin/reports/usageByObjectId', filter)({ type: REPORT_LOAD_DATA })
  )
}

export const loadDemographicData = filter => {
  return h2Api.post('/admin/reports/demographic', filter)({ type: REPORT_LOAD_DATA })
}

export const updateField = (k, v) => dispatch => {
  dispatch({ type: UPDATE_REPORT_FIELD, key: k, val: v })
}
